import { memo, useEffect, useState } from 'react'
import { useAppDispatch } from '../../../../../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../../../../../hooks/useAppSelector'
import { selectRuleConfigBit } from '../../../../../../../store/selectors/ruleCardSelectors'
import { PATH_JOINER } from '../../../../../utils/getConfigBitPath'
import { useFormValidation } from '../../../../../../../hooks/useFormValidation'
import { getLabel } from '../../../../../../../utils/getLabel'
import {
    buildControlsExt,
    checkboxInput,
} from '../../../../../../inputs/controls'
import {
    initRuleEmptyData,
    modifyRuleCardConfig,
} from '../../../../../../../store/actions/ruleCardActions'

interface Props {
    dataPath: string
    dataSchema: any
    name: string
    wrapper?: string
    isViewOnly?: boolean
}

export const RuleBool = memo(function RuleBool({
    dataPath,
    dataSchema = {},
    name,
    wrapper,
    isViewOnly,
}: Props) {
    const {
        description,
        is_nullable: isNullable,
        name: inputLabel,
        default: defaultValue,
        change_warning: changeWarning,
    } = dataSchema

    const dispatch = useAppDispatch()
    const pathSplit = dataPath.split(PATH_JOINER)
    const configBit = useAppSelector(selectRuleConfigBit(pathSplit))
    const [inputState, setInputState, touched] = useFormValidation(
        configBit || {},
        {}
    )
    const [isChanged, setIsChanged] = useState(inputState?.[name])
    const label: string = getLabel(name, inputLabel)
    const path = [...pathSplit, name]

    const controlDescriptors = [
        checkboxInput(
            name,
            description,
            label,
            '',
            isViewOnly,
            '',
            isNullable,
            defaultValue,
            changeWarning
        ),
    ]

    const BoolInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched
    )

    useEffect(() => {
        if (dataPath?.length) {
            if (
                !configBit ||
                !Object.keys(configBit).length ||
                typeof configBit?.[name] === 'undefined'
            ) {
                dispatch(initRuleEmptyData({ schema: dataSchema, name, path }))
            }
        }
    }, []) // eslint-disable-line

    useEffect(() => {
        if (configBit && dataPath?.length) {
            setInputState(configBit)
        }
    }, [configBit]) // eslint-disable-line

    useEffect(() => {
        if (isChanged !== inputState?.[name] && dataPath?.length) {
            setIsChanged(inputState?.[name])
            dispatch(modifyRuleCardConfig({ path, data: inputState }))
        }
    }, [inputState]) // eslint-disable-line

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{BoolInput}</div>
})
